/**
 * @generated SignedSource<<9e7ac2ef3f624e5aba0497e60e9adf60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventMembersEditFormFragment$data = {
  readonly id: string;
  readonly viewerCanEditMembers: boolean;
  readonly " $fragmentType": "EventMembersEditFormFragment";
};
export type EventMembersEditFormFragment$key = {
  readonly " $data"?: EventMembersEditFormFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventMembersEditFormFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventMembersEditFormFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": "viewerCanEditMembers",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "ADD_EVENT_MEMBER"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"ADD_EVENT_MEMBER\")"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "d7be17a2022bc45226c11340c8fd4abe";

export default node;
